<template>
  <vx-card class="mt-2 pagebreak-inside-avoid">
    <table class="table">
      <tr class="title p-1 w-full">
        <th colspan="4">RENOVAÇÃO</th>
      </tr>
      <tr>
        <td class="pl-3">
          <b>É uma renovação?</b>:
          {{
            getInsuranceCompanyLabel(
              proposalData.bonus.insurance_company_code,
              insuranceCompanies,
            )
          }}
        </td>
        <td v-if="proposalData.bonus.ci" class="pl-3">
          <b>CI anterior</b>:
          {{ proposalData.bonus.ci }}
        </td>
        <td v-if="proposalData.bonus.policy_number" class="pl-3">
          <b>N° da apólice anterior</b>:
          {{ proposalData.bonus.policy_number }}
        </td>
      </tr>
      <tr>
        <td v-if="proposalData.bonus.previous_coverage_end_date" class="pl-3">
          <b>Fim da vigência anterior</b>:
          {{
            functions.formataDataHoraPadraoBR(
              proposalData.bonus.previous_coverage_end_date,
              false,
            )
          }}
        </td>
        <td v-if="proposalData.bonus.is_renovation" class="pl-3">
          <b>Veículo igual ao anterior?</b>:
          {{ getVehicleIsSameLabel(proposalData.bonus.is_same_vehicle) }}
        </td>
      </tr>
    </table>
    <div
      v-if="customSectionsMsgs.RENEWAL"
      style="text-align: justify"
      class="pl-3 pt-3"
      v-html="customSectionsMsgs.RENEWAL"
    ></div>
  </vx-card>
</template>

<script>
import { getInsuranceCompanyLabel } from '../../../services/contract';
import pdfApi from '../../../services/pdf.api';
import functions from '../../../utils/functions.js';

export default {
  name: 'EndorsementContractBonus',
  props: {
    proposalData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    customSectionsMsgs: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      getInsuranceCompanyLabel,
      insuranceCompanies: [],
      functions,
    };
  },
  created() {
    this.getCongeners();
  },
  methods: {
    async getCongeners() {
      pdfApi
        .getCongenersLabeled(this.proposalData.bonus.insurance_company_code)
        .then((res) => {
          res.forEach((congener) => {
            this.insuranceCompanies.push({
              id: congener.susep_code,
              label: congener.name,
            });
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getVehicleIsSameLabel(is_same_vehicle) {
      return is_same_vehicle ? 'Sim' : 'Não';
    },
  },
};
</script>
